export default __webpack_public_path__ + "static/author-46031ff8182384fd48e3a0a8d9618fc8.jpg";